// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"6e942083","508":"6039ebce"}[chunkId] + ".chunk.css";
};